/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var normalizeComponent = require('../../normalize-component-d885d5ff.js');

//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: "MqChecked",
  data: function data() {
    return {};
  },
  props: {
    type: {
      type: String,
      default: "green"
    },
    size: {
      type: String,
      default: "medium"
    },
    check: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    }
  },
  methods: {
    triggerEvent: function triggerEvent() {
      this.$emit("checked");
    }
  }
};

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: [_vm.type, _vm.size],
      staticStyle: { display: "flex", "align-items": "center" },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "align-items": "center" },
          on: { click: _vm.triggerEvent },
        },
        [
          _vm.check
            ? _c("svg", { attrs: { "aria-hidden": "true" } }, [
                _c("use", { attrs: { "xlink:href": "#bf-checkbox-fill" } }),
              ])
            : _c("svg", { attrs: { "aria-hidden": "true" } }, [
                _c("use", {
                  attrs: { "xlink:href": "#bf-checkbox-blank-line" },
                }),
              ]),
          _vm._v(" "),
          _c("div", {
            staticStyle: { "margin-left": "4px" },
            domProps: { innerHTML: _vm._s(_vm.text) },
          }),
        ]
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-bdd466a4";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

__vue_component__.install = function (Vue) {
  Vue.component(__vue_component__.name, __vue_component__);
};

module.exports = __vue_component__;
